export default __webpack_public_path__ + "static/media/feature_respin.d67f9774.jpg";